export interface PayPeriodSummary {
  hours: number;
  amount: number;
}

export interface PaySummary {
  week: PayPeriodSummary;
  month: PayPeriodSummary;
  year: PayPeriodSummary;
}
